import { Fragment } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import AuthLayout from '../components/layout/auth';
import AdminLayout from '../components/layout/admin/main';
import AdminLayoutPrint from '../components/layout/admin/main-print';

import ManagerLayout from '../components/layout/manager/main';
import ManagerLayoutPrint from '../components/layout/manager/main-print';

import AssistantManagerLayout from '../components/layout/assistant-manager/main';
import AssistantManagerLayoutPrint from '../components/layout/assistant-manager/main-print';

import OverseerLayout from '../components/layout/overseer/main';
import OverseerLayoutPrint from '../components/layout/overseer/main-print';


import Login from '../components/auth/login';
import ForgotPassword from '../components/auth/forgot-password';
import PageNotFound from '../components/pagenotfound';
import ChangePassword from '../components/auth/change-password';



import AdminDashboard from '../components/admin/dashboard';

import AdminSettingsProperty from '../components/admin/settings/property';
import AdminSettingsFloor from "../components/admin/settings/floor";
import AdminSettingsRoom from "../components/admin/settings/room";
import AdminSettingsBedType from "../components/admin/settings/bedType";
import AdminSettingsBed from "../components/admin/settings/bed";
import AdminSettingsAvailableBeds from "../components/admin/settings/availableBed";



import AdminSettingsPhase from "../components/admin/settings/phase";
import AdminSettingsMasterTask from "../components/admin/settings/masterTaskList";
import AdminSettingsAdditionalItem from "../components/admin/settings/additionalItem";


import AdminGuestManagementGuest from "../components/admin/guest-management/guest";
import AdminGuestManagementGuestPrevious from "../components/admin/guest-management/guest-previous";
import AdminGuestManagementGuestIntakeForm from "../components/admin/guest-management/guest-intake-form";
import AdminGuestManagementGuestIntakeFormMoveIn from "../components/admin/guest-management/guest-intake-form-move-in";
import AdminGuestManagementGuestIntakeFormMoveInDoor from "../components/admin/guest-management/guest-intake-form-move-in-door";

import AdminGuestManagementGuestIntakeFormReview from "../components/admin/guest-management/guest-intake-form-review";
import AdminGuestManagementGuestIntakeFormPayment from "../components/admin/guest-management/guest-intake-form-payment";
import AdminGuestManagementGuestIntakeFormView from "../components/admin/guest-management/guest-intake-form-view";
import AdminGuestManagementAssignRoles from '../components/admin/guest-management/assign-roles'
import AdminGuestManagementReassignBedGuestList from '../components/admin/guest-management/reassign-bed-guest-list'
import AdminGuestManagementReassignBed from '../components/admin/guest-management/reassign-bed'

import AdminGuestManagementGuestIntakeRequests from '../components/admin/guest-management/guest-intake-requests'


import AdminGuestManagementGuestRequest from '../components/admin/guest-management/guest-request'
import AdminGuestManagementSignConsent from '../components/admin/guest-management/sign-consent'
import AdminGuestManagementGuestLocation from '../components/admin/guest-management/guest-location'



import AdminPayments from '../components/admin/payments/payments'
import AdminPaidPayments from '../components/admin/payments/paid-payments'
import AdminPendingPayments from '../components/admin/payments/pending-payments'
import AdminUpcomingPayments from '../components/admin/payments/upcoming-payments'

import AdminPaymentsAdd from '../components/admin/payments/add-payment'
import AdminPaymentsAddOnline from '../components/admin/payments/add-payment-online'



import AdminDrugScreeningResultList from "../components/admin/drug-screening-result/list";
import AdminDrugScreeningResultFiles from "../components/admin/drug-screening-result/files";
import AdminFormManagementList from "../components/admin/form-management/list";
import AdminNotificationsList from "../components/admin/notifications/list";
import AdminNotificationsSend from "../components/admin/notifications/send";



import AdminTasksList from "../components/admin/tasks/list";
import AdminTasksCreate from "../components/admin/tasks/create";
import AdminTasksListDetail from "../components/admin/tasks/list-detail";
import AdminTasksListDetailPrint from "../components/admin/tasks/list-detail-print";



import AdminMeetingsList from "../components/admin/meetings/list";
import AdminMeetingsCreate from "../components/admin/meetings/create";
import AdminMeetingsEdit from "../components/admin/meetings/edit";
import AdminMeetingsView from "../components/admin/meetings/view";
import AdminLiveChat from "../components/admin/live-chat/chat";

import AdminDocumentsList from "../components/admin/documents/list";
import AdminDocumentsCreate from "../components/admin/documents/create";



import ManagerDashboard from '../components/manager/dashboard';
import ManagerDrugScreeningResultList from "../components/manager/drug-screening-result/list";
import ManagerDrugScreeningResultFiles from "../components/manager/drug-screening-result/files";
import ManagerMeetingsList from "../components/manager/meetings/list";
import ManagerMeetingsView from "../components/manager/meetings/view";
import ManagerMeetingsEdit from "../components/manager/meetings/edit";
import ManagerMeetingsCreate from "../components/manager/meetings/create";
import ManagerSignConsentView from "../components/manager/sign-consent/view";


import ManagerTasksList from "../components/manager/tasks/list";
import ManagerTasksCreate from "../components/manager/tasks/create";
import ManagerTasksListDetail from "../components/manager/tasks/list-detail";
import ManagerTasksListDetailPrint from "../components/manager/tasks/list-detail-print";
import ManagerLiveChat from "../components/manager/live-chat/chat";


import AssistantManagerDashboard from '../components/assistant-manager/dashboard';
import AssistantManagerMeetingsList from "../components/assistant-manager/meetings/list";
import AssistantManagerMeetingsView from "../components/assistant-manager/meetings/view";
import AssistantManagerTasksList from "../components/assistant-manager/tasks/list";
import AssistantManagerTasksCreate from "../components/assistant-manager/tasks/create";
import AssistantManagerTasksListDetail from "../components/assistant-manager/tasks/list-detail";
import AssistantManagerTasksListDetailPrint from "../components/assistant-manager/tasks/list-detail-print";
import AssistantManagerLiveChat from "../components/assistant-manager/live-chat/chat";
import AssistantManagerSignConsentView from "../components/assistant-manager/sign-consent/view";


import OverseerDashboard from '../components/overseer/dashboard';
import OverseerDrugScreeningResultList from "../components/overseer/drug-screening-result/list";
import OverseerDrugScreeningResultFiles from "../components/overseer/drug-screening-result/files";
import OverseerMeetingsList from "../components/overseer/meetings/list";
import OverseerMeetingsView from "../components/overseer/meetings/view";
import OverseerMeetingsEdit from "../components/overseer/meetings/edit";
import OverseerMeetingsCreate from "../components/overseer/meetings/create";
import OverseerSignConsentView from "../components/overseer/sign-consent/view";

import OverseerTasksList from "../components/overseer/tasks/list";
import OverseerTasksCreate from "../components/overseer/tasks/create";
import OverseerTasksListDetail from "../components/overseer/tasks/list-detail";
import OverseerTasksListDetailPrint from "../components/overseer/tasks/list-detail-print";
import OverseerLiveChat from "../components/overseer/live-chat/chat";


import OverseerGuestManagementGuest from "../components/overseer/guest-management/guest";
import OverseerGuestManagementGuestIntakeForm from "../components/overseer/guest-management/guest-intake-form";
import OverseerGuestManagementGuestIntakeFormMoveIn from "../components/overseer/guest-management/guest-intake-form-move-in";
import OverseerGuestManagementGuestIntakeFormMoveInDoor from "../components/overseer/guest-management/guest-intake-form-move-in-door";
import OverseerGuestManagementGuestIntakeFormReview from "../components/overseer/guest-management/guest-intake-form-review";
import OverseerGuestManagementGuestIntakeFormView from "../components/overseer/guest-management/guest-intake-form-view";


const AllRoutes = () => {
    return (
        <Fragment>
            <BrowserRouter basename='/'>
                <Routes>
                    <Route path="/" element={<Navigate to="/login" />} />

                    <Route element={<AuthLayout />}>
                        <Route path="/login" element={<Login />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />

                    </Route>


                    <Route element={<AdminLayout />}>
                        <Route path="/admin/"   >
                            <Route path="dashboard" element={<AdminDashboard />} />

                            <Route path="settings/properties" element={<AdminSettingsProperty />} />
                            <Route path="settings/floors" element={<AdminSettingsFloor />} />
                            <Route path="settings/rooms" element={<AdminSettingsRoom />} />
                            <Route path="settings/bed-types" element={<AdminSettingsBedType />} />
                            <Route path="settings/beds" element={<AdminSettingsBed />} />
                            <Route path="settings/available-beds" element={<AdminSettingsAvailableBeds />} />

                            <Route path="settings/phases" element={<AdminSettingsPhase />} />
                            <Route path="settings/additional-items" element={<AdminSettingsAdditionalItem />} />
                            <Route path="settings/master-tasks" element={<AdminSettingsMasterTask />} />

                            <Route path="guest-management/guest" element={<AdminGuestManagementGuest />} />
                            <Route path="guest-management/guest-previous" element={<AdminGuestManagementGuestPrevious />} />

                            <Route path="guest-management/guest-intake-form/:id?" element={<AdminGuestManagementGuestIntakeForm />} />
                            <Route path="guest-management/guest-intake-form-move-in/:id" element={<AdminGuestManagementGuestIntakeFormMoveIn />} />
                            <Route path="guest-management/guest-intake-form-move-in-door/:id" element={<AdminGuestManagementGuestIntakeFormMoveInDoor />} />

                            <Route path="guest-management/guest-intake-form-review/:id" element={<AdminGuestManagementGuestIntakeFormReview />} />
                            <Route path="guest-management/guest-intake-form-payment/:id/:is_recurring" element={<AdminGuestManagementGuestIntakeFormPayment />} />
                            <Route path="guest-management/guest-intake-form-view/:id" element={<AdminGuestManagementGuestIntakeFormView />} />
                            <Route path="guest-management/assign-roles" element={<AdminGuestManagementAssignRoles />} />
                            <Route path="guest-management/reassign-bed-guest-list" element={<AdminGuestManagementReassignBedGuestList />} />
                            <Route path="guest-management/reassign-bed/:id" element={<AdminGuestManagementReassignBed />} />

                            
                            <Route path="guest-management/guest-intake-requests" element={<AdminGuestManagementGuestIntakeRequests />} />

                            <Route path="guest-management/guest-request/:id" element={<AdminGuestManagementGuestRequest />} />
                            <Route path="guest-management/sign-consent/:id" element={<AdminGuestManagementSignConsent />} />
                          
                            <Route path="guest-management/guest-location/:id" element={<AdminGuestManagementGuestLocation />} />


                            <Route path="payments" element={<AdminPayments />} />
                            <Route path="payments/paid" element={<AdminPaidPayments />} />
                            <Route path="payments/pending" element={<AdminPendingPayments />} />
                            <Route path="payments/upcoming" element={<AdminUpcomingPayments />} />


                            <Route path="add-payment/:id" element={<AdminPaymentsAdd />} />
                            <Route path="add-payment-online/:id" element={<AdminPaymentsAddOnline />} />



                            <Route path="drug-screening-result/list" element={<AdminDrugScreeningResultList />} />
                            <Route path="drug-screening-result/view-result-files/:guest_id" element={<AdminDrugScreeningResultFiles />} />

                            <Route path="form-management/list" element={<AdminFormManagementList />} />

                            <Route path="notifications/list" element={<AdminNotificationsList />} />
                            <Route path="notifications/send" element={<AdminNotificationsSend />} />

                            <Route path="tasks/list" element={<AdminTasksList />} />
                            <Route path="tasks/view/:date" element={<AdminTasksListDetail />} />
                            <Route path="tasks/create" element={<AdminTasksCreate />} />
                            <Route path="meetings/list" element={<AdminMeetingsList />} />
                            <Route path="meetings/create" element={<AdminMeetingsCreate />} />
                            <Route path="meetings/edit/:id" element={<AdminMeetingsEdit />} />
                            <Route path="meetings/view/:id" element={<AdminMeetingsView />} />
                            <Route path="live-chat" element={<AdminLiveChat />} />

                            <Route path="documents/list" element={<AdminDocumentsList />} />
                            <Route path="documents/create" element={<AdminDocumentsCreate />} />
                            <Route path="change-password" element={<ChangePassword />} />



                        </Route>
                    </Route>
                    <Route element={<AdminLayoutPrint />}>
                        <Route path="/admin/"   >

                            <Route path="tasks/print/:date" element={<AdminTasksListDetailPrint />} />

                        </Route>
                    </Route>





                    <Route element={<ManagerLayout />}>
                        <Route path="/manager/"   >
                            <Route path="dashboard" element={<ManagerDashboard />} />
                            <Route path="drug-screening-result/list" element={<ManagerDrugScreeningResultList />} />
                            <Route path="drug-screening-result/view-result-files/:guest_id" element={<ManagerDrugScreeningResultFiles />} />
                            <Route path="tasks/list" element={<ManagerTasksList />} />
                            <Route path="tasks/view/:date" element={<ManagerTasksListDetail />} />
                            <Route path="tasks/create" element={<ManagerTasksCreate />} />
                            <Route path="meetings/list" element={<ManagerMeetingsList />} />
                            <Route path="meetings/create" element={<ManagerMeetingsCreate />} />
                            <Route path="meetings/edit/:id" element={<ManagerMeetingsEdit />} />
                            <Route path="meetings/view/:id" element={<ManagerMeetingsView />} />
                            <Route path="live-chat" element={<ManagerLiveChat />} />
                            <Route path="sign-consent/view" element={<ManagerSignConsentView />} />
                            <Route path="change-password" element={<ChangePassword />} />


                        </Route>
                    </Route>
                    <Route element={<ManagerLayoutPrint />}>
                        <Route path="/manager/"   >

                            <Route path="tasks/print/:date" element={<ManagerTasksListDetailPrint />} />

                        </Route>
                    </Route>




                    <Route element={<AssistantManagerLayout />}>
                        <Route path="/assistant-manager/"   >
                            <Route path="dashboard" element={<AssistantManagerDashboard />} />
                            <Route path="tasks/list" element={<AssistantManagerTasksList />} />
                            <Route path="tasks/view/:date" element={<AssistantManagerTasksListDetail />} />
                            <Route path="tasks/create" element={<AssistantManagerTasksCreate />} />
                            <Route path="meetings/list" element={<AssistantManagerMeetingsList />} />
                            <Route path="meetings/view/:id" element={<AssistantManagerMeetingsView />} />
                            <Route path="live-chat" element={<AssistantManagerLiveChat />} />
                            <Route path="sign-consent/view" element={<AssistantManagerSignConsentView />} />
                            <Route path="change-password" element={<ChangePassword />} />

                        </Route>
                    </Route>

                    <Route element={<AssistantManagerLayoutPrint />}>
                        <Route path="/assistant-manager/"   >

                            <Route path="tasks/print/:date" element={<AssistantManagerTasksListDetailPrint />} />

                        </Route>
                    </Route>




                    <Route element={<OverseerLayout />}>
                        <Route path="/overseer/"   >

                            <Route path="dashboard" element={<OverseerDashboard />} />
                            <Route path="drug-screening-result/list" element={<OverseerDrugScreeningResultList />} />
                            <Route path="drug-screening-result/view-result-files/:guest_id" element={<OverseerDrugScreeningResultFiles />} />
                            <Route path="tasks/list" element={<OverseerTasksList />} />
                            <Route path="tasks/view/:date" element={<OverseerTasksListDetail />} />
                            <Route path="tasks/create" element={<OverseerTasksCreate />} />
                            <Route path="meetings/list" element={<OverseerMeetingsList />} />
                            <Route path="meetings/create" element={<OverseerMeetingsCreate />} />
                            <Route path="meetings/edit/:id" element={<OverseerMeetingsEdit />} />
                            <Route path="meetings/view/:id" element={<OverseerMeetingsView />} />
                            <Route path="live-chat" element={<OverseerLiveChat />} />
                            <Route path="sign-consent/view" element={<OverseerSignConsentView />} />


                            <Route path="guest-management/guest" element={<OverseerGuestManagementGuest />} />
                            <Route path="guest-management/guest-intake-form/:id?" element={<OverseerGuestManagementGuestIntakeForm />} />
                            <Route path="guest-management/guest-intake-form-move-in/:id" element={<OverseerGuestManagementGuestIntakeFormMoveIn />} />
                            <Route path="guest-management/guest-intake-form-move-in-door/:id" element={<OverseerGuestManagementGuestIntakeFormMoveInDoor />} />
                            <Route path="guest-management/guest-intake-form-review/:id" element={<OverseerGuestManagementGuestIntakeFormReview />} />
                            <Route path="guest-management/guest-intake-form-view/:id" element={<OverseerGuestManagementGuestIntakeFormView />} />

                            <Route path="change-password" element={<ChangePassword />} />


                        </Route>
                    </Route>

                    <Route element={<OverseerLayoutPrint />}>
                        <Route path="/overseer/"   >

                            <Route path="tasks/print/:date" element={<OverseerTasksListDetailPrint />} />

                        </Route>
                    </Route>




                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </BrowserRouter>
        </Fragment>
    );

};

export default AllRoutes;
